const config = {
  apiBaseUrl: "https://operations.roadpilot.co.in/public/api",
  apiImageUrl: "https://mobile.roadpilot.co.in/public/",
  apiTripsUrl: "https://mobile.roadpilot.co.in/public/",
};

export default config;
